/**
 * Die Auslauf-Regel auf der Frontend-Seite — EINE Stelle, nicht je Bildschirm.
 *
 * 🔴 Die Uhr ist der UTC-Tag, nicht der Ortstag. Das ist keine Kleinigkeit:
 * alle fuenf Backend-Leser der Regel rechnen mit `now_utc().date()`, und
 * `backend/tests/test_discontinued_filter.py:445`
 * (`test_ALLE_leser_der_regel_lesen_DIESELBE_uhr`) existiert ausdruecklich,
 * WEIL ein Leser einmal `date.today()` benutzte und abdriftete — gemessen mit
 * `TZ=Pacific/Midway`.
 *
 * ⚠️ Jener Waechter durchsucht **nur Backend-Python**. Diese Datei ist der
 * sechste Leser derselben Regel und liegt strukturell ausserhalb seines
 * Blickfelds: er bliebe gruen, waehrend hier etwas driftet. Darum die eigene
 * Probe in `discontinued.test.js`, gefahren unter `TZ=Pacific/Auckland`
 * (`npm run test:tz`) — eine Zeitzone, in der Orts- und UTC-Tag die halbe Zeit
 * auseinanderfallen.
 *
 * 🔴 Die idiomatischen JS-Wege geben den ORTSTAG und sind deshalb falsch:
 * `toLocaleDateString()`, `date-fns/format`, `new Date().getDate()`. Richtig
 * ist der ISO-Schnitt, wie ihn `ProductDetail.jsx:372` schon benutzt.
 */

/** Der heutige Tag als `YYYY-MM-DD` in UTC — dieselbe Uhr wie das Backend. */
export function heuteUtcIso() {
  return new Date().toISOString().slice(0, 10)
}

/**
 * Wirkt der Auslauf schon? `<= heute`, NICHT `!= null`.
 *
 * Ein Datum in der ZUKUNFT ist eine Ankuendigung und gilt noch nicht — genau
 * dafuer gibt es das Feld. Der Vergleich laeuft als Zeichenkette, weil
 * `YYYY-MM-DD` lexikographisch dieselbe Ordnung hat wie chronologisch; ein
 * `new Date(...)` daraus haette wieder eine Zeitzone im Bauch.
 *
 * @param {string|null|undefined} discontinuedAt ISO-Tag oder leer
 * @param {string} [heute] nur zum Pruefen ueberschreibbar
 * @returns {boolean} true = wird NICHT mehr nachbestellt
 */
export function auslaufWirktSchon(discontinuedAt, heute = heuteUtcIso()) {
  if (!discontinuedAt) return false
  return String(discontinuedAt).slice(0, 10) <= heute
}

/**
 * Ein ISO-Tag als `TT.MM.JJJJ` — OHNE den Umweg ueber `new Date`.
 *
 * 🔴 `new Date('2027-03-12').toLocaleDateString('de-DE')` ist UTC-Mitternacht
 * und kippt westlich von Greenwich auf den Vortag. `ProductDetail.jsx` nimmt
 * genau diesen Weg und vermerkt die Falle im Kommentar; hier wird die
 * Zeichenkette zerlegt, wie es `DeclinedProductsDrawer.jsx:39` schon tut.
 * Dieselbe Zeitzonenfalle wie bei der Uhr oben, nur eine Ebene weiter.
 */
export function formatAuslaufTag(iso) {
  if (!iso) return '—'
  const [j, m, t] = String(iso).slice(0, 10).split('-')
  return (j && m && t) ? `${t}.${m}.${j}` : String(iso)
}

/**
 * Verschwindet die Zeile nach dem Speichern aus den Empfehlungen?
 *
 * Die Antwort ist genau `auslaufWirktSchon` — aber unter eigenem Namen, weil
 * an dieser Stelle eine ANDERE Frage gestellt wird als „ist es ausgelaufen".
 * Der Drawer zeigt, was `GET /api/recommended_purchase_orders` liefert, und
 * jene Route filtert mit derselben Grenze (`routes.py:2103`). Faellt die eine
 * Zeile, muss die andere mitfallen.
 */
export const zeileFaelltAusDenEmpfehlungen = auslaufWirktSchon
